module.exports = __webpack_public_path__ + "static/media/file-pdf_active.b1c5d505.svg";